import { render, staticRenderFns } from "./add_resource_talents.vue?vue&type=template&id=0131f409&scoped=true"
import script from "./add_resource_talents.vue?vue&type=script&lang=js"
export * from "./add_resource_talents.vue?vue&type=script&lang=js"
import style0 from "./add_resource_talents.vue?vue&type=style&index=0&id=0131f409&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131f409",
  null
  
)

export default component.exports